import {RoleService} from "@/services/RoleService";

export function setUser(state, user) {
    state.user = user
    state.isLogged = true
    state.error = false
    state.errorMessage = ''
    state.invalid = false
}

export function setGeolocation(state, geolocation) {
    console.log('setGeolocation', geolocation)
    state.geolocation = geolocation
}

export function authError(state, message) {
    state.errorMessage = message
    if (message === 'Invalid') {
        state.invalid = true
    } else {
        state.invalid = false
    }
    state.user = null
    state.isLogged = false
    state.error = true

}

export function user_roles(state) {
    return state.user.user_roles;
}

export async function setRoleAvailable(state) {
    state.roles = await RoleService.all();
}

export function logout(state, message) {
    state.message = message || '';
    state.user = null
    state.isLogged = false
}
